export default __webpack_public_path__ + "static/media/ic-transaction.d28e30f7.svg";